module.exports = __webpack_public_path__ + "img/stage_drachenkopf2.e96a01df.jpg";